import $ from 'jquery';

$(document).ready(function () {
  acfPostGridBlock();
  $(window).on('resize', acfPostGridBlock);
});

function acfPostGridBlock() {
  $('.js-acf-post-grid').each(function () {
    const $grid = $(this);
    const $buttons = $grid.find('button.wp-block-button__link');

    if ($buttons.length === 0) return;

    $buttons.css('height', 'auto');

    let maxHeight = 0;
    $buttons.each(function () {
      const btnHeight = $(this).outerHeight();
      if (btnHeight > maxHeight) maxHeight = btnHeight;
    });

    $buttons.css('height', maxHeight + 'px');
  });
}
